<div #content class="content">
  <ng-content />
</div>
@if (content.hasChildNodes()) {
  <hr />
}
@if (!hideProgressBar) {
  <shared-progress-bar [progress]="progress" color="#8F909F" [showTitle]="true" />
}
<div class="actions">
  @if (!hideBackButton) {
    <button
      pButton
      class="p-button p-button-grey icon-only"
      [class.icon-only]="showBackButtonIcon && !backButtonLabel"
      type="submit"
      (click)="goBack()">
      @if (showBackButtonIcon) {
        <shared-icon fill="white" icon="triangle-left" height="1rem" width="1rem" />
      }
      @if (backButtonLabel) {
        <span>{{ backButtonLabel }}</span>
      }
    </button>
  }
  @if (!showSkipButton) {
    <button
      pButton
      class="p-button p-button-primary"
      [class.icon-only]="showBackButtonIcon && !backButtonLabel"
      type="submit"
      [loading]="loading"
      [disabled]="!forwardButtonEnabled"
      (click)="goForward()">
      @if (!loading) {
        <span class="no-wrap">{{ forwardButtonLabel }}</span>
        @if (showForwardButtonIcon) {
          <shared-icon fill="white" icon="arrow-right" height="0.75rem" width="0.75rem" />
        }
      }
    </button>
  }
  @if (showSkipButton) {
    <button
      pButton
      class="p-button p-button-primary"
      [class.icon-only]="showBackButtonIcon && !backButtonLabel"
      type="submit"
      (click)="goForward()">
      <span>SKIP</span>
      @if (showForwardButtonIcon) {
        <shared-icon fill="white" icon="arrow-right" height="0.75rem" width="0.75rem" />
      }
    </button>
  }
</div>
